import { createContext } from "react";

export const UserContext = createContext();
export const UserSummaryContext = createContext(); 
export const UserIncentiveSummaryContext = createContext();
export const UserPendingPromotionsContext = createContext();